import React from "react";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import {Trans, useTranslation} from "react-i18next";
import LoginForm from "../forms/LoginForm";
import RegisterForm from "../forms/RegisterForm";
import {SubmissionError, submit} from "redux-form";
import {login, LOGIN_FAILURE, SIGN_UP_FAILURE, signUp} from "../../../actions/UserActions";
import {getPhoneCode} from "../../../helpers/PhoneHelper";
import {useDispatch, useSelector} from "react-redux";
import {TimeOffset} from "../../../helpers/TimeHelper";
import {
    HTTP_STATUS_CODE_INVALID_PASSWORD,
    HTTP_STATUS_CODE_USER_DOES_NOT_EXIST
} from "../../../../../../common/constants/HttpStatusCode";

function AuthTabs({signUpEnabled, loginBtnTitle, registerBtnTitle, children, successCallback}) {
    const {code} = useSelector(state => state.country);
    const {phoneCodes} = useSelector(state => state.dictionary);
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const handleLogin = values => {
        return dispatch(login(values)).then(data => {
            if (data.type === LOGIN_FAILURE) {
                const errors = {};
                switch (data.payload.status) {
                    case HTTP_STATUS_CODE_USER_DOES_NOT_EXIST: errors.email = t('User doesn\'t exist.'); break;
                    case HTTP_STATUS_CODE_INVALID_PASSWORD: errors.password = t('Password is incorrect.'); break;
                    default: errors.email = t('Something went wrong.');
                }

                throw new SubmissionError(errors);
            }

            successCallback && successCallback();
        });
    }

    const handleRegister = values => {
        const data = {
            email: values.email,
            name: 'Customer',
            phone: getPhoneCode(values.phone.code, phoneCodes) + ' ' + values.phone.number,
            user_time_offset: TimeOffset(),
            subscribe: values.subscribe ? 1 : 0
        };

        return dispatch(signUp(data)).then(data => {
            if (data.type === SIGN_UP_FAILURE) {
                const errors = {
                    phone: {},
                };
                switch (data.payload.status) {
                    case 452: errors.email = t('User already exists.'); break;
                    case 455: errors.email = t('Forbidden email domain.'); break;
                    case 456: errors.email = t('Did you mean {{suggestion}}?', {suggestion: data.payload.response.message}); break;
                    default: errors.email = t('Something went wrong.');
                }

                throw new SubmissionError(errors);
            }

            successCallback && successCallback();
        });
    }

    const getIsoCode = (value) => {
        return value ? value.toLowerCase() : undefined;
    }

    const submitLoginForm = () => {
        dispatch(submit('LoginForm'))
    }

    const submitRegisterForm = () => {
        dispatch(submit('RegisterForm'))
    }

    return <Tabs className="tabs" selectedTabClassName="tabs-active">
        <TabList className="tabs-nav">
            <Tab><Trans>I already have an account</Trans></Tab>
            {signUpEnabled && <Tab><Trans>Create an account</Trans></Tab>}
        </TabList>
        <TabPanel className="columns">
            <LoginForm onSubmit={handleLogin} />
            {children}
            <div className="alignright mobile-hidden">
                <button
                    type="button"
                    className="btn pink checkout-button"
                    onClick={submitLoginForm}
                >
                    {loginBtnTitle || 'LOG IN'}
                </button>
            </div>
        </TabPanel>
        <TabPanel className="columns">
            <RegisterForm
                onSubmit={handleRegister}
                initialValues={{
                    phone: {
                        code: getIsoCode(code)
                    }
                }}
            />
            {children}
            <div className="alignright mobile-hidden">
                <button
                    type="button"
                    className="btn pink checkout-button"
                    onClick={submitRegisterForm}
                >
                    {registerBtnTitle || 'REGISTER'}
                </button>
            </div>
        </TabPanel>
    </Tabs>
}

export default AuthTabs